const [d] = [document];

export default class Header {
  constructor(selector = '[data-header]') {
    this.header = d.querySelector(selector);
    if (!this.header) return;

    this.nav = this.header.querySelector('[data-header-nav]');
    this.toggle = this.header.querySelector('[data-header-toggle]');
    this.menuLabel = this.header.querySelector('[data-menu-label]');
    this.isOpen = false;
    this.scrollTicking = false;

    this.bindEvents();
    this.updateScrollState();
  }

  bindEvents() {
    this.toggle.addEventListener('click', () => this.toggleMenu());

    this.nav.addEventListener('click', (event) => {
      if (event.target.closest('a')) this.closeMenu();
    });

    d.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeMenu(true);
    });

    window.addEventListener('scroll', () => this.requestScrollUpdate(), { passive: true });
  }

  requestScrollUpdate() {
    if (this.scrollTicking) return;
    this.scrollTicking = true;
    window.requestAnimationFrame(() => {
      this.updateScrollState();
      this.scrollTicking = false;
    });
  }

  updateScrollState() {
    this.header.classList.toggle('is-scrolled', window.scrollY > 80);
  }

  toggleMenu() {
    this.isOpen ? this.closeMenu(true) : this.openMenu();
  }

  openMenu() {
    this.isOpen = true;
    this.header.classList.add('is-active');
    this.toggle.classList.add('is-active');
    this.toggle.setAttribute('aria-expanded', 'true');
    this.menuLabel.textContent = 'CLOSE';
    d.body.classList.add('is-menu-open');
  }

  closeMenu(returnFocus = false) {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.header.classList.remove('is-active');
    this.toggle.classList.remove('is-active');
    this.toggle.setAttribute('aria-expanded', 'false');
    this.menuLabel.textContent = 'MENU';
    d.body.classList.remove('is-menu-open');
    if (returnFocus) this.toggle.focus();
  }
}
